/*
 * <steals-cookie-notice> — aviso de cookies da Steals (opt-out no Brasil).
 *
 * Quem decide se o banner NATIVO da Shopify aparece e a propria Shopify (Configuracoes >
 * Privacidade do cliente > Banner de cookies > Regioes). Este cartao so entra onde o
 * nativo nao entra, e some assim que o visitante registra qualquer escolha: no "Ok"
 * daqui ou no modal de preferencias, que e da Shopify e abre pelo link do rodape.
 *
 * Spec: docs/specs/2026-10-06-aviso-cookies.md
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'steals_cookies_ok';

  var SAIDA_MS = 250; // margem acima dos 200ms da transicao de saida

  function lerStorage() {
    try { return window.localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }

  function gravarStorage() {
    try { window.localStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* bloqueado: o cookie da Shopify basta */ }
  }

  // Alguma escolha ja registrada (sim ou nao) em qualquer categoria?
  function jaEscolheu(consent) {
    if (!consent) return false;
    return ['marketing', 'analytics', 'preferences'].some(function (k) {
      return consent[k] === 'yes' || consent[k] === 'no';
    });
  }

  // Regra unica de visibilidade. Pura de proposito: e o que o teste exercita.
  function deveMostrar(estado) {
    if (estado.designMode) return true;
    if (estado.shouldShowBanner) return false;
    if (jaEscolheu(estado.consent)) return false;
    if (estado.storageOk) return false;
    return true;
  }

  function chamar(obj, metodo, fallback) {
    try { return typeof obj[metodo] === 'function' ? obj[metodo]() : fallback; } catch (e) { return fallback; }
  }

  function quandoCarregar(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn, { once: true });
  }

  class StealsCookieNotice extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      this.botao = this.querySelector('.steals-cookies__ok');
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      var self = this;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (erro) {
        if (erro) return;
        self.iniciar();
      });
    }

    iniciar() {
      var cp = window.Shopify.customerPrivacy;
      if (!cp) return;
      this.cp = cp;
      this.designMode = !!window.Shopify.designMode;
      var estado = {
        designMode: this.designMode,
        shouldShowBanner: chamar(cp, 'shouldShowBanner', false),
        consent: chamar(cp, 'currentVisitorConsent', null),
        storageOk: lerStorage()
      };
      if (!deveMostrar(estado)) return;

      var self = this;
      if (this.botao) this.botao.addEventListener('click', function () { self.aceitar(); });
      // Qualquer escolha registrada em outro lugar (modal de preferencias) tambem encerra o aviso.
      document.addEventListener('visitorConsentCollected', function () { self.esconder(); });
      // Com o modal de preferencias aberto (link do rodape), o cartao sai da frente.
      document.addEventListener('steals:cookie-prefs-open', function () { self.classList.add('is-yielding'); });
      this.observarAvisoSacola();

      var atraso = this.designMode ? 0 : (parseInt(this.dataset.delay || '0', 10) || 0);
      quandoCarregar(function () { setTimeout(function () { self.mostrar(); }, atraso); });
    }

    mostrar() {
      if (!this.hasAttribute('hidden')) return;
      this.removeAttribute('hidden');
      var self = this;
      // Dois frames: o primeiro pinta o estado inicial, o segundo dispara a transicao.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { self.classList.add('is-open'); });
      });
    }

    // "Ok" grava consentimento positivo nas tres categorias. No editor de tema nao grava
    // nada: o operador so quer ver o cartao pra editar o texto.
    aceitar() {
      if (!this.designMode) {
        gravarStorage();
        try {
          this.cp.setTrackingConsent(
            { analytics: true, marketing: true, preferences: true, sale_of_data: true },
            function () {}
          );
        } catch (e) { /* sem API nao ha o que gravar; o aviso some do mesmo jeito */ }
      }
      this.esconder();
    }

    esconder() {
      if (this.hasAttribute('hidden')) return;
      var self = this;
      this.classList.remove('is-open');
      this.classList.add('is-leaving');
      var feito = false;
      function fechar() {
        if (feito) return;
        feito = true;
        self.classList.remove('is-leaving');
        self.setAttribute('hidden', '');
      }
      this.addEventListener('transitionend', fechar, { once: true });
      setTimeout(fechar, SAIDA_MS);
    }

    // O aviso de "adicionado a sacola" usa o mesmo canto no mobile. Enquanto ele
    // estiver aberto, o cartao some; quando ele fecha, o cartao volta.
    observarAvisoSacola() {
      var aviso = document.querySelector('cart-notification');
      if (!aviso || typeof MutationObserver === 'undefined') return;
      var self = this;
      var obs = new MutationObserver(function () {
        self.classList.toggle('is-yielding', aviso.classList.contains('is-open'));
      });
      obs.observe(aviso, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (!customElements.get('steals-cookie-notice')) {
    customElements.define('steals-cookie-notice', StealsCookieNotice);
  }

  // Link "Preferencias de cookies" (rodape ou onde for): abre o modal nativo da Shopify.
  // Sem a API, o link segue o href normalmente (Politica de Privacidade).
  document.addEventListener('click', function (e) {
    var alvo = e.target && e.target.closest ? e.target.closest('[data-steals-cookie-prefs]') : null;
    if (!alvo) return;
    var pb = window.privacyBanner;
    if (!pb || typeof pb.showPreferences !== 'function') return;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('steals:cookie-prefs-open'));
    try { pb.showPreferences(); } catch (err) { window.location.href = alvo.href; }
  });
})();
